
import { gapiCall } from './gapi';

// Create subscription action types
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";

// Update subscription action types
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS";
export const UPDATE_SUBSCRIPTION_ERROR = "UPDATE_SUBSCRIPTION_ERROR";

// Request subscription users (ie licences) action types
export const REQUEST_SUBSCRIPTION_USERS = "REQUEST_SUBSCRIPTION_USERS";
export const REQUEST_SUBSCRIPTION_USERS_SUCCESS = "REQUEST_SUBSCRIPTION_USERS_SUCCESS";
// FIXME: error ?

// Request subscription invitations action types
export const REQUEST_SUBSCRIPTION_INVITATIONS = "REQUEST_SUBSCRIPTION_INVITATIONS";
export const REQUEST_SUBSCRIPTION_INVITATIONS_SUCCESS = "REQUEST_SUBSCRIPTION_INVITATIONS_SUCCESS";
// FIXME: error

// Request subscription domains action types
export const REQUEST_SUBSCRIPTION_DOMAINS = "REQUEST_SUBSCRIPTION_DOMAINS";
export const REQUEST_SUBSCRIPTION_DOMAINS_SUCCESS = "REQUEST_SUBSCRIPTION_DOMAINS_SUCCESS";
// FIXME: error ?

// Invite users to subscription action types
export const INVITE_USERS = "INVITE_USERS";
export const INVITE_USERS_SUCCESS = "INVITE_USERS_SUCCESS";
export const INVITE_USERS_ERROR = "INVITE_USERS_ERROR";

// Remove user from subscription action types
export const REMOVE_USER = "REMOVE_USER";
export const REMOVE_USER_SUCCESS = "REMOVE_USER_SUCCESS";
export const REMOVE_USER_ERROR = "REMOVE_USER_ERROR";

// Add user from subscription action types
export const ADD_USER = "ADD_USER";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_ERROR = "ADD_USER_ERROR";

// Request subscription by ID action types
export const REQUEST_SUBSCRIPTION = "REQUEST_SUBSCRIPTION";
export const REQUEST_SUBSCRIPTION_SUCCESS = "REQUEST_SUBSCRIPTION_SUCCESS";
export const REQUEST_SUBSCRIPTION_ERROR = "REQUEST_SUBSCRIPTION_ERROR";

// Sync subscription by Chargify ID action types
export const SYNC_SUBSCRIPTION = "SYNC_SUBSCRIPTION";
export const SYNC_SUBSCRIPTION_SUCCESS = "SYNC_SUBSCRIPTION_SUCCESS";
export const SYNC_SUBSCRIPTION_ERROR = "SYNC_SUBSCRIPTION_ERROR";

// Cancel (or pause) subscription action types
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_ERROR = "CANCEL_SUBSCRIPTION_ERROR";

// Reactivate (or resume) subscription action types
export const REACTIVATE_SUBSCRIPTION = "REACTIVATE_SUBSCRIPTION";
export const REACTIVATE_SUBSCRIPTION_WITHOUT_WORKING_STATE = "REACTIVATE_SUBSCRIPTION_WITHOUT_WORKING_STATE";
export const REACTIVATE_SUBSCRIPTION_SUCCESS = "REACTIVATE_SUBSCRIPTION_SUCCESS";
export const REACTIVATE_SUBSCRIPTION_ERROR = "REACTIVATE_SUBSCRIPTION_ERROR";

// Dismiss a subscription warning
export const DISMISS_SUBSCRIPTION_WARNING = "DISMISS_SUBSCRIPTION_WARNING";
export const DISMISS_SUBSCRIPTION_WARNING_SUCCESS = "DISMISS_SUBSCRIPTION_WARNING_SUCCESS";
export const DISMISS_SUBSCRIPTION_WARNING_ERROR = "DISMISS_SUBSCRIPTION_WARNING_ERROR";

// greeting display
export const DISPLAY_SUBSCRIPTION_GREETING = "DISPLAY_SUBSCRIPTION_GREETING";
export const HIDE_SUBSCRIPTION_GREETING = "HIDE_SUBSCRIPTION_GREETING";

// Store PlanId in local storage (needed in case of a redirection to Chargify Payment Info form)
export const STORE_LOCAL_CHOOSEN_PLAN_ID = "STORE_LOCAL_CHOOSEN_PLAN_ID";
export const REMOVE_LOCAL_CHOOSEN_PLAN_ID = "REMOVE_LOCAL_CHOOSEN_PLAN_ID";

/**
 * Create subscription action creator
 * @param {String} accountId Account to create the subscription into
 * @param {String} productId Product to subscribe to
 * @param {String} planId Plan to subscribe to
 * @param {Integer} licencesCount Number of licences to purchase
 */
const createSubscription = (accountId, productId, planId, licencesCount) => {
  return {
    type: CREATE_SUBSCRIPTION,
    accountId,
    productId,
    planId,
    licencesCount
  };
}

/**
 * Create subscription success action creator
 * @param {String} accountId The account ID into which the subscription was created
 * @param {Object} subscription The created subscription
 */
const createSubscriptionSuccess = (accountId, subscription) => {
  return {
    type: CREATE_SUBSCRIPTION_SUCCESS,
    accountId,
    subscription
  }
}

/**
 * Create subscription error action creator
 * Triggered when encoutering an error creating the subscription 
 * @param {String} accountId 
 * @param {String} productId 
 * @param {String} planId 
 * @param {Integer} licencesCount 
 * @param {Error} error 
 */
const createSubscriptionError = (accountId, productId, planId, licencesCount, error) => {
  return {
    type: CREATE_SUBSCRIPTION_ERROR,
    accountId,
    productId,
    planId,
    licencesCount,
    error
  }
}

/**
 * Update subscription action creator
 * @param {String} subscriptionId The subscription to update
 * @param {String} planId The plan to switch the subscription to
 * @param {Integer} licencesCount The number of licences to set
 */
const updateSubscription = (subscriptionId, planId, licencesCount) => {
  return {
    type: UPDATE_SUBSCRIPTION,
    subscriptionId,
    planId,
    licencesCount
  };
}

/**
 * Update subscription success action creator
 * @param {Object} subscription The updated subscription
 */
export const updateSubscriptionSuccess = (subscription) => {
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    subscription
  }
}

/**
 * Update subscription error action creator
 * // FIXME: should contain planId and licencesCount ?
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
const updateSubscriptionError = (subscriptionId, error) => {
  return {
    type: UPDATE_SUBSCRIPTION_ERROR,
    subscriptionId,
    error
  }
}

/**
 * Request subscription users page action creator
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum number of users to return
 * @param {String} token Page token
 */
const requestSubscriptionUsers = (subscriptionId, limit, token) => {
  return {
    type: REQUEST_SUBSCRIPTION_USERS,
    subscriptionId,
    limit,
    token
  }
}

/**
 * Request subscription users page success action creator
 * @param {String} subscriptionId 
 * @param {Array} items Array of users (ie licences) for that page
 * @param {Integer} totalCount Total number of users in that licence
 * @param {String} token Current page token
 * @param {String} nextPageToken Next page token
 */
const requestSubscriptionUsersSuccess = (subscriptionId, items, totalCount, token, nextPageToken) => {
  return {
    type: REQUEST_SUBSCRIPTION_USERS_SUCCESS,
    subscriptionId,
    totalCount,
    nextPageToken,
    token,
    items
  }
}

/**
 * Request subscription invitations action creator
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum number of invitations to return
 * @param {String} token Page token to retrieve
 */
const requestSubscriptionInvitations = (subscriptionId, limit, token) => {
  return {
    type: REQUEST_SUBSCRIPTION_INVITATIONS,
    subscriptionId,
    limit,
    token
  }
}

/**
 * Request subscription invitations success action creator
 * @param {String} subscriptionId 
 * @param {Array} items Array of invitations for that page
 * @param {Integer} totalCount Total number of invitations for that subscription
 * @param {String} token Current page token
 * @param {String} nextPageToken Next page token
 */
const requestSubscriptionInvitationsSuccess = (subscriptionId, items, totalCount, token, nextPageToken) => {
  return {
    type: REQUEST_SUBSCRIPTION_INVITATIONS_SUCCESS,
    subscriptionId,
    totalCount,
    token,
    nextPageToken,
    items
  }
}

/**
 * Request subscription domains action creator
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum number of invitations to return
 * @param {String} token Page token to retrieve
 */
const requestSubscriptionDomains = (subscriptionId, limit, token) => {
  return {
    type: REQUEST_SUBSCRIPTION_DOMAINS,
    subscriptionId,
    limit,
    token
  }
}

/**
 * Request subscription domains success action creator
 * @param {String} subscriptionId 
 * @param {Array} items Array of invitations for that page
 * @param {Integer} totalCount Total number of invitations for that subscription
 * @param {String} token Current page token
 * @param {String} nextPageToken Next page token
 */
const requestSubscriptionDomainsSuccess = (subscriptionId, items, totalCount, token, nextPageToken) => {
  return {
    type: REQUEST_SUBSCRIPTION_DOMAINS_SUCCESS,
    subscriptionId,
    totalCount,
    token,
    nextPageToken,
    items
  }
}

/**
 * Invite users action creator
 * @param {String} subscriptionId 
 * @param {String} emails Comma separated list of emails
 */
const inviteUsers = (subscriptionId, emails) => {
  return {
    type: INVITE_USERS,
    subscriptionId,
    emails
  }
}

/**
 * Invite users success action creator
 * @param {String} subscriptionId 
 * @param {Array} invitations Invitations created
 */
const inviteUsersSuccess = (subscriptionId, invitations) => {
  return {
    type: INVITE_USERS_SUCCESS,
    subscriptionId,
    invitations
  }
}

/**
 * Invite users error action creator
 * @param {String} subscriptionId 
 * @param {String} emails Comma separated list of emails
 * @param {Error} error 
 */
const inviteUsersError = (subscriptionId, emails, error) => {
  return {
    type: INVITE_USERS_ERROR,
    subscriptionId,
    emails,
    error
  }
}

/**
 * Remove user from subscription action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
const removeUser = (subscriptionId, userId) => {
  return {
    type: REMOVE_USER,
    subscriptionId,
    userId
  }
}

/**
 * Remove user from subscription success action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
const removeUserSuccess = (subscriptionId, userId) => {
  return {
    type: REMOVE_USER_SUCCESS,
    subscriptionId,
    userId
  }
}

/**
 * Remove user from subscription error action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 * @param {Error} error 
 */
const removeUserError = (subscriptionId, userId, error) => {
  return {
    type: REMOVE_USER_ERROR,
    subscriptionId,
    userId,
    error
  }
}

/**
 * Add user to subscription action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
const addUser = (subscriptionId, userId) => {
  return {
    type: ADD_USER,
    subscriptionId,
    userId
  }
}

/**
 * Add user to subscription success action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
const addUserSuccess = (subscriptionId, userId) => {
  return {
    type: ADD_USER_SUCCESS,
    subscriptionId,
    userId
  }
}

/**
 * Add user to subscription error action creator
 * @param {String} subscriptionId 
 * @param {String} userId 
 * @param {Error} error 
 */
const addUserError = (subscriptionId, userId, error) => {
  return {
    type: ADD_USER_ERROR,
    subscriptionId,
    userId,
    error
  }
}

/**
 * Request subscription action creator
 * @param {String} subscriptionId 
 */
const requestSubscription = subscriptionId => {
  return {
    type: REQUEST_SUBSCRIPTION,
    subscriptionId
  }
}

/**
 * Request subscription success action creator
 * @param {Object} subscription 
 */
const requestSubscriptionSuccess = subscription => {
  return {
    type: REQUEST_SUBSCRIPTION_SUCCESS,
    subscription
  }
}

/**
 * Request subscription error action creator
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
const requestSubscriptionError = (subscriptionId, error) => {
  return {
    type: REQUEST_SUBSCRIPTION_ERROR,
    subscriptionId,
    error
  }
}

/**
 * Synchronize subscription by chargify ID action creator
 * @param {String} chargifyId Chargify ID of the subscription to synchronize
 */
const syncSubscription = chargifyId => {
  return {
    type: SYNC_SUBSCRIPTION,
    chargifyId
  }
}

/**
 * Synchronize subscription by chargify success ID action creator
 * @param {Object} subscription The subscription synchronized from chargify 
 */
const syncSubscriptionSuccess = subscription => {
  return {
    type: SYNC_SUBSCRIPTION_SUCCESS,
    subscription
  }
}

/**
 * Synchronize subscription by chargify ID error action creator
 * @param {String} chargifyId Chargify ID
 * @param {Error} error 
 */
const syncSubscriptionError = (chargifyId, error) => {
  return {
    type: SYNC_SUBSCRIPTION_ERROR,
    chargifyId,
    error
  }
}

/**
 * Cancel subscription action creator
 * @param {String} subscriptionId 
 */
const cancelSubscription = subscriptionId => ({
  type: CANCEL_SUBSCRIPTION,
  subscriptionId
});

/**
 * Cancel subscription success action creator
 * @param {Object} subscription 
 */
const cancelSubscriptionSuccess = subscription => ({
  type: CANCEL_SUBSCRIPTION_SUCCESS,
  subscription
});

/**
 * Cancel subscription error action creator
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
const cancelSubscriptionError = (subscriptionId, error) => ({
  type: CANCEL_SUBSCRIPTION_ERROR,
  subscriptionId,
  error
});

/**
 * Reactivate subscription action creator
 * @param {String} subscriptionId 
 */
const reactivateSubscription = subscriptionId => ({
  type: REACTIVATE_SUBSCRIPTION,
  subscriptionId
});

/**
 * Reactivate subscription action creator when we want to skip the apiToggle action 
 * @param {String} subscriptionId 
 */
const reactivateSubscriptionWithoutWorkingState = subscriptionId => ({
  type: REACTIVATE_SUBSCRIPTION_WITHOUT_WORKING_STATE,
  subscriptionId
});

/**
 * Reactivate subscription success action creator
 * @param {Object} subscription 
 */
const reactivateSubscriptionSuccess = subscription => ({
  type: REACTIVATE_SUBSCRIPTION_SUCCESS,
  subscription
});

/**
 * Reactivate subscription error action creator
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
const reactivateSubscriptionError = (subscriptionId, error) => ({
  type: REACTIVATE_SUBSCRIPTION_ERROR,
  subscriptionId,
  error
});

/**
 * Dismiss subscription warning action creator
 * @param {String} subscriptionId 
 */
const dismissSubscriptionWarning = (subscriptionId, alertId) => ({
  type: DISMISS_SUBSCRIPTION_WARNING,
  subscriptionId,
  alertId
});

/**
 * Dismiss subscription warning success action creator
 * @param {Object} subscription 
 */
const dismissSubscriptionWarningSuccess = (subscriptionId, alertId) => ({
  type: DISMISS_SUBSCRIPTION_WARNING_SUCCESS,
  subscriptionId,
  alertId
});

/**
 * Dismiss subscription warning error action creator
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
const dismissSubscriptionWarningError = (subscriptionId, alertId, error) => ({
  type: DISMISS_SUBSCRIPTION_WARNING_ERROR,
  subscriptionId,
  alertId,
  error
});

export const allActions = {
  requestSubscriptionInvitationsSuccess,
  inviteUsersSuccess
};

/**
 * Creates a subscription and dispatches the corresponding actions
 * @param {String} accountId Account to create the subscription into
 * @param {String} productId Product to subscribe to
 * @param {String} planId Plan to subscribe to
 * @param {Integer} licencesCount Number of licences to purchase
 */
export const doCreateSubscription = (accountId, productId, planId, licencesCount = 1) => dispatch =>
  dispatch(createSubscription(accountId, productId, planId, licencesCount))
  && dispatch(gapiCall(client => client.billing.subscriptions.create({
    accountId,
    productId,
    planId,
    licencesCount
  })))
    .then(subscription => dispatch(createSubscriptionSuccess(accountId, subscription)))
    .catch(error => dispatch(createSubscriptionError(accountId, productId, planId, licencesCount, error)))

/**
 * Updates a subscription and dispatches the corresponding actions
 * @param {String} subscriptionId The subscription to update
 * @param {String} planId The plan to switch to
 * @param {String} licencesCount Number of licences to set for this subscription
 */
export const doUpdateSubscription = (subscriptionId, planId, licencesCount = 1) => dispatch =>
  dispatch(updateSubscription(subscriptionId, planId, licencesCount))
  && dispatch(gapiCall(client => client.billing.subscriptions.update({
    subscriptionId,
    planId,
    licencesCount
  })))
    .then(subscription => dispatch(updateSubscriptionSuccess(subscription)))
    .catch(error => dispatch(updateSubscriptionError(subscriptionId, error)));

/**
 * Send invitations to join this subscription 
 * @param {String} subscriptionId Subscription to invite to
 * @param {String} emails Comma separated list of emails
 */
export const doInviteUsers = (subscriptionId, emails) => dispatch =>
  dispatch(inviteUsers(subscriptionId, emails))
  && dispatch(gapiCall(client => client.billing.subscriptions.invitations.add({
    subscriptionId,
    emails
  })))
    .then(res => dispatch(inviteUsersSuccess(subscriptionId, res.items)))
    .catch(error => dispatch(inviteUsersError(subscriptionId, emails, error)))

/**
 * Remove user from subscription.
 * (Only allowed if user is logged in or user is owner of the subscription)
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
export const doRemoveUser = (subscriptionId, userId) => dispatch =>
  dispatch(removeUser(subscriptionId, userId))
  && dispatch(gapiCall(client => client.billing.subscriptions.licences.delete({ subscriptionId, userId })))
    .then(_ => dispatch(removeUserSuccess(subscriptionId, userId)))
    .catch(error => dispatch(removeUserError(subscriptionId, error)))

/**
 * Add user to subscription
 * (Currently limited to "add myself to my subscription")
 * @param {String} subscriptionId 
 * @param {String} userId 
 */
export const doAddUser = (subscriptionId, userId) => dispatch =>
  dispatch(addUser(subscriptionId, userId))
  && dispatch(gapiCall(client => client.billing.subscriptions.users.add({ subscriptionId, userId })))
    .then(res => dispatch(addUserSuccess(subscriptionId, userId)))
    .catch(err => dispatch(addUserError(subscriptionId, userId, err)))

/**
 * Fetches a page of users from this subscription
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum users to retrieve
 * @param {String} pageToken Token of the page to retrieve 
 */
export const fetchSubscriptionUsers = (subscriptionId, limit, pageToken) => dispatch =>
  dispatch(requestSubscriptionUsers(subscriptionId, limit, pageToken))
  && dispatch(gapiCall(client => client.billing.subscriptions.users.list({ subscriptionId, limit, pageToken, excludeOwner: true })))
    .then(result => dispatch(requestSubscriptionUsersSuccess(
        subscriptionId,
        result.items || [],
        result.totalCount,
        pageToken,
        result.nextPageToken
    )))

/**
 * Fetches a page of invitations to this subscription
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum number of invitations to retrieve
 * @param {String} pageToken Token of the page to retrieve
 */
export const fetchSubscriptionInvitations = (subscriptionId, limit, pageToken) => dispatch => 
  dispatch(requestSubscriptionInvitations(subscriptionId, limit, pageToken))
  && dispatch(gapiCall(client => client.billing.subscriptions.invitations.list({ subscriptionId, limit, pageToken })))
    .then(result => dispatch(requestSubscriptionInvitationsSuccess(
      subscriptionId,
      result.items || [],
      result.totalCount,
      pageToken,
      result.nextPageToken
    )));

/**
 * Fetches a page of domains to this subscription
 * @param {String} subscriptionId 
 * @param {Integer} limit Maximum number of invitations to retrieve
 * @param {String} pageToken Token of the page to retrieve
 */
export const fetchSubscriptionDomains = (subscriptionId, limit, pageToken) => dispatch => 
  dispatch(requestSubscriptionDomains(subscriptionId, limit, pageToken))
  && dispatch(gapiCall(client => client.billing.subscriptions.domainInvitations.list({ subscriptionId, limit, pageToken })))
    .then(result => dispatch(requestSubscriptionDomainsSuccess(
      subscriptionId,
      result.items || [],
      result.totalCount,
      pageToken,
      result.nextPageToken
    )));

/**
 * Fetches a subscription by ID
 * @param {String} subscriptionId 
 */
export const fetchSubscription = subscriptionId => dispatch =>
  dispatch(requestSubscription(subscriptionId))
  && dispatch(gapiCall(client => client.billing.subscriptions.get({ subscriptionId, includes: "usersCount" })))
    .then(subscription => dispatch(requestSubscriptionSuccess(subscription)))
    .catch(error => dispatch(requestSubscriptionError(subscriptionId, error)))

/**
 * Synchronizes a subscription by chargify ID (see ChargifyRedirect container)
 * @param {String} chargifyId The ID of the subscription in chargify 
 */
export const syncSubscriptionByChargifyId = chargifyId => dispatch =>
  dispatch(syncSubscription(chargifyId))
  && dispatch(gapiCall(client => client.billing.subscriptions.sync({ chargifyId })))
    .then(subscription => dispatch(syncSubscriptionSuccess(subscription)))
    .catch(error => dispatch(syncSubscriptionError(chargifyId, error)))

/**
 * Cancels (or pauses) a subscription
 * @param {String} subscriptionId 
 */
export const doCancelSubscription = subscriptionId => dispatch =>
  dispatch(cancelSubscription(subscriptionId))
  && dispatch(gapiCall(client => client.billing.subscriptions.cancel({ subscriptionId })))
    .then(subscription => dispatch(cancelSubscriptionSuccess(subscription)))
    .catch(error => dispatch(cancelSubscriptionError(subscriptionId, error)))

/**
 * Reactivates (or resumes) a subscription
 * @param {String} subscriptionId 
 */
export const doReactivateSubscription = (subscriptionId, workingState = true) => dispatch => {
  if (workingState) {
    dispatch(reactivateSubscription(subscriptionId));
  } else {
    dispatch(reactivateSubscriptionWithoutWorkingState(subscriptionId));
  }
  return dispatch(gapiCall(client => client.billing.subscriptions.reactivate({ subscriptionId })))
    .then(subscription => dispatch(reactivateSubscriptionSuccess(subscription)))
    .catch(error => dispatch(reactivateSubscriptionError(subscriptionId, error)));
}
// Key in local storage in which to redirect after chargify redirects to us
const CHARGIFY_REDIRECT_URL = 'chargifyRedirectUrl';

/**
 * Redirects to the subscription's Chargify payment page (Self Service page)
 * Stores the redirect URL to local storage, then navigates to chargify
 * @param {Object} subscription 
 * @param {String} chargifyRedirectUrl Local url to redirect after Chargify redirects to us
 */
export const setPaymentInfo =   (subscription, chargifyRedirectUrl) => dispatch => {
  if (!chargifyRedirectUrl) {
    // if no url provided, redirect to current location
    const { pathname, search } = document.location;
    chargifyRedirectUrl = pathname + search;
  }
  localStorage.setItem(CHARGIFY_REDIRECT_URL, chargifyRedirectUrl);
  document.location.href = subscription.paymentInfoUrl;
}

export const doDismissSubscriptionWarning = (subscriptionId, alertId) => dispatch => {
  return dispatch(dismissSubscriptionWarning(subscriptionId, alertId))
    && dispatch(gapiCall(client => client.billing.subscriptions.alerts.dismiss({ subscriptionId, alertId })))
      .then(_ => dispatch(dismissSubscriptionWarningSuccess(subscriptionId, alertId)))
      .catch(error => dispatch(dismissSubscriptionWarningError(subscriptionId, alertId)))
}

/**
 * Redirects the user to the appropriate page after Chargify has redirected to us
 * Redirects to the subscription page by default
 * @param {Object} subscription 
 * @param {Object} history React router / navigator history object
 */
export const redirectFromChargify = (subscription, history) => dispatch => {
  // FIXME: duplicate from withNavigation
  return history.push(`/subscriptions/${subscription.id}/update`);
}

const displaySubscriptionGreeting = (subscriptionId) => ({
  type: DISPLAY_SUBSCRIPTION_GREETING,
  subscriptionId: subscriptionId,
});

const hideSubscriptionGreeting = (subscriptionId) => ({
  type: HIDE_SUBSCRIPTION_GREETING,
  subscriptionId: subscriptionId,
});

const greetingKey = subscriptionId => `subscriptions.${subscriptionId}.greeting`;

export const doDisplaySubscriptionGreeting = subscriptionId => dispatch => {
  dispatch( displaySubscriptionGreeting(subscriptionId) );
  localStorage.setItem(greetingKey(subscriptionId), '1');
}

export const doHideSubscriptionGreeting = subscriptionId => dispatch => {
  dispatch( hideSubscriptionGreeting(subscriptionId) );
  localStorage.removeItem(greetingKey(subscriptionId));
}

export const getSubscriptionGreetingFromLocalStorage = subscriptionId => dispatch => {
  if( localStorage.getItem(greetingKey(subscriptionId)) ) {
    dispatch(displaySubscriptionGreeting(subscriptionId));
  } else {
    dispatch(hideSubscriptionGreeting(subscriptionId));
  }
}

const storeLocalChoosenPlanInfo = (planId, licencesCount) => ({
  type: STORE_LOCAL_CHOOSEN_PLAN_ID,
  planId: planId,
  licencesCount: licencesCount,
});

const removeLocalChoosenPlanInfo = (planId, licencesCount) => ({
  type: REMOVE_LOCAL_CHOOSEN_PLAN_ID,
  planId: planId,
  licencesCount: licencesCount,
});

export const CHOOSEN_PLAN_KEY = "CHOOSEN_PLAN_KEY";

export const LICENCES_COUNT_KEY = "LICENCES_COUNT_KEY";

export const doStoreChoosenPlanInfo = (planId, licencesCount) => dispatch => {
  localStorage.setItem(CHOOSEN_PLAN_KEY, planId);
  localStorage.setItem(LICENCES_COUNT_KEY, licencesCount);
  dispatch( storeLocalChoosenPlanInfo(planId) );
}

export const doRemoveLocalChoosenPlanInfo = (planId, licencesCount) => dispatch => {
  localStorage.removeItem(CHOOSEN_PLAN_KEY);
  localStorage.removeItem(LICENCES_COUNT_KEY);
  dispatch( removeLocalChoosenPlanInfo(planId, licencesCount) );
}



// WEBPACK FOOTER //
// ./src/actions/subscriptions.js